export function titleCase(str) {
  str = str.toLowerCase().split(' ')

  let final = []

  for (let word of str) {
    final.push(word.charAt(0).toUpperCase() + word.slice(1))
  }

  return final.join(' ')
}
